<div class="refferal-section">
  <div class="col-lg-12">
    <div class="referral-budgets">
      <div class="card referral-card">
        <img src="./assets/img/Icon/Copy.png" (click)="copyRefCode()" />
        <div clas="referral-text" (click)="copyRefCode()">
          <h1 class="title-gradient gradient-pp">Your Invite Code:</h1>
          <p>{{refCode}}
          </p>
        </div>
        <div class="share-buttons">
          <!-- [style.backgroundColor]="fbBtn?.color" -->
          <button shareButton="messenger" #fbBtn="shareButton" [url]="shareUrl" [style.backgroundColor]="'#0080FF'">
            <fa-icon *ngIf="fbBtn" [icon]="['fab', 'facebook-f']" size="lg"></fa-icon>
          </button>
          <!-- [style.backgroundColor]="whatsappBtn?.color" -->
          <button shareButton="whatsapp" #whatsappBtn="shareButton" [style.backgroundColor]="'#25D366'"
            [url]="shareUrl">
            <fa-icon *ngIf="whatsappBtn" [icon]="['fab', 'whatsapp']" size="lg"></fa-icon>
          </button>
          <!-- [style.backgroundColor]="telegramBtn?.color" -->
          <button shareButton="telegram" #telegramBtn="shareButton" [style.backgroundColor]="'#0088cc'"
            [url]="shareUrl">
            <fa-icon *ngIf="telegramBtn" [icon]="['fab', 'telegram']" size="lg"></fa-icon>
          </button>
          <!-- [style.backgroundColor]="twitterBtn?.color" -->
          <button shareButton="twitter" #twitterBtn="shareButton" [style.backgroundColor]="'#00acee'"
            [url]="shareUrl">
            <fa-icon *ngIf="twitterBtn" [icon]="['fab', 'twitter']" size="lg"></fa-icon>
          </button>
        </div>
      </div>
      <div class="card referral-budget">
        <div class="referra-budget-item">
          <h1 class="title-gradient gradient-pp">Friends Referred: {{friendsInvited}}</h1>
        </div>
        <div class="divider"></div>
        <div class="referra-budget-item">
          <h1 class="title-gradient gradient-pp">Loyalty Points: {{loyaltyBudget}}</h1>
        </div>
      </div>
    </div>
  </div>
  <!--<div class="row d-flex justify-content-center mb-4">
    <div class="filter-wrapper mt-5">
      <button>ALL</button>
      <button>STAR TICKET</button>
      <button> FOOD</button>
      <button>TOYS</button>
      <button>HEALTH</button>
    </div>
  </div>-->
  <div class="items-shop">
    <div class="col-lg-6 col">
      <div class="card items-card">
        <div class="filter-wrapper">
          <button (click)="selectFilter(null)">ALL</button>
          <button (click)="selectFilter('ticket')">TRAINING TICKETS</button>
          <button (click)="selectFilter('food')"> FOOD</button>
          <button (click)="selectFilter('toy')">TOYS</button>
          <button (click)="selectFilter('medicinal')">HEALTH</button>
        </div>
        <div class="item" *ngFor="let item of items | itemsFilter:filterValue; let i = index ">
          <!--<div class="item-header">
            <div class="item-header-pill">
              {{item.price}} KMON
            </div>
           <div class="item-header-value">
              <span><img src="./assets/img/Icon/medal.png" /></span>
              <span>1.27</span>
            </div>
          </div>-->
          <div class="item-image">
            <img src={{item.imageSrc}} alt="item image">
          </div>
          <div class="item-text">
            <h1>{{item.name}}</h1>
            <!--<p>TYPE: {{item.type}}</p>-->
          </div>
          <div class="item-actions">
            <div class="loaylty-price">
              <img src="./assets/img/Icon/medal.png" />
              <p>{{item.loyaltyprice}}</p>
            </div>
            <div class="button-outline" (click)="redeemItem(item.ItemId, i)"
              *ngIf="item.loyaltyprice<=loyaltyBudget && !items[i].selected && !isLoading && !items[i].success">
              Redeem
            </div>
            <div class="button-gradient" *ngIf="item.loyaltyprice<=loyaltyBudget && items[i].selected">
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
            </div>
            <div class="button-gradient" *ngIf="item.loyaltyprice<=loyaltyBudget && items[i].success">
              <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </div>
            <div class="button-outline disabled"
              *ngIf="item.loyaltyprice>loyaltyBudget || (isLoading && !items[i].selected)">
              Redeem
            </div>
          </div>
          <!--<div class="item-footer">
            <div>
              <p>{{item.name}}</p>
              <p>TYPE: {{item.type}}</p>
            </div>
            <div>
              <img src="./assets/img/Icon/Label-Referral.png" />
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="col-lg-6 col">
      <div class="card instruction-card" *ngIf="isNew">
        <p>As a new player the following actions will reward you with Kryptomon Loyalty Points, these are a great way to
          start your Journey into the Kryptomon Game and get some extra rewards!</p>
        <div class="divider"></div>
        <div class="instruction-item">
          <h1 [ngClass]="{'task-completed': taskCompleted.buyLogin}">Buy Kryptomon &amp; Login in Game</h1>
          <div class="loaylty-price" *ngIf="!taskCompleted.buyLogin">
            <img src="./assets/img/Icon/medal.png" />
            <p>40</p>
          </div>
          <div class="loaylty-price" *ngIf="taskCompleted.buyLogin">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
          </div>
        </div>
        <div class="instruction-item">
          <h1 [ngClass]="{'task-completed': taskCompleted.winPractice}">Win Practice Battle</h1>
          <div class="loaylty-price" *ngIf="!taskCompleted.winPractice">
            <img src="./assets/img/Icon/medal.png" />
            <p>5</p>
          </div>
          <div class="loaylty-price" *ngIf="taskCompleted.winPractice">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
          </div>
        </div>
        <div class="instruction-item">
          <h1 [ngClass]="{'task-completed': taskCompleted.completeFullQuest}">Complete Full Quest</h1>
          <div class="loaylty-price" *ngIf="!taskCompleted.completeFullQuest">
            <img src="./assets/img/Icon/medal.png" />
            <p>10</p>
          </div>
          <div class="loaylty-price" *ngIf="taskCompleted.completeFullQuest">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
          </div>
        </div>
      </div>
      <div class="card instruction-card">
        <p>These are recurring activities that you can do to earn points!</p>
        <div class="divider"></div>
        <div class="instruction-item">
          <h1>Referring a new active player with a bought Kryptomon</h1>
          <div class="loaylty-price">
            <img src="./assets/img/Icon/medal.png" />
            <p>100</p>
          </div>
        </div>
        <div class="instruction-item">
          <h1>Breed Kryptomon</h1>
          <div class="loaylty-price">
            <img src="./assets/img/Icon/medal.png" />
            <p>30</p>
          </div>
        </div>
      </div>
      <div class="card instruction-card">
        <p>If your Referred Friend will do these actions then you'll also earn points!</p>
        <div class="divider"></div>
        <div class="instruction-item">
          <h1>Breed Kryptomon</h1>
          <div class="loaylty-price">
            <img src="./assets/img/Icon/medal.png" />
            <p>30</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>